import type { CustomerRead } from "../../customer-management/services/customerTypes";
import type { SiteRead } from "../../site-management/services/siteTypes";
import type { LocationRead } from "../../location-management/services/locationTypes";

export const meterTagTypes: MeterTagType[] = ["MeterList"];
export type MeterTagType = "MeterList";

export type MetersListApiResponse = /** status 200  */ PaginatedMeterListRead;
export type MetersListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  location?: number;
  locationSite?: number;
  locationSiteCustomer?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  sort?: string;
  status?: string;
  type?: string;
  meter_url?: string;
};
export type MetersCreateApiResponse = /** status 201  */ MeterRead;
export type MetersCreateApiArg = {
  createRequest: MeterRequest;
};
export type MetersRetrieveApiResponse = /** status 200  */ MeterRead;
export type MetersRetrieveApiArg = {
  /** A unique integer value identifying this meter. */
  id: number;
  include?: string[];
};
export type MetersUpdateApiResponse = /** status 200  */ MeterRead;
export type MetersUpdateApiArg = {
  /** A unique integer value identifying this meter. */
  id: number;
  updateRequest: MeterRequest;
};
export type MetersPartialUpdateApiResponse = /** status 200  */ MeterRead;
export type MetersPartialUpdateApiArg = {
  /** A unique integer value identifying this meter. */
  id: number;
  patchedMeterRequest: PatchedMeterRequest;
};
export type MetersDestroyApiResponse = unknown;
export type MetersDestroyApiArg = {
  /** A unique integer value identifying this meter. */
  id: number;
};
export type Meter = {
  name: string;
  type: string;
  unit: string;
  make: string;
  model: string;
  serial: string;
  status: string;
  commissioning_date: string;
  meter_url?: string;
};
export type MeterRead = {
  id: number;
  site: SiteRead;
  customer: CustomerRead;
  location: LocationRead;
  created_at: string;
  updated_at: string;
  name: string;
  type: "SolarMeter" | "GridSubMeter" | "MainGridMeter";
  unit: string;
  mac_address: string;
  make: string;
  model: string;
  serial: string;
  status: string;
  commissioning_date: string;
  meter_url?: string;
  predicted_monthly: number[];
};
export type PaginatedMeterList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Meter[];
};
export type PaginatedMeterListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MeterRead[];
};
export type MeterRequest = {
  name: string;
  type: string;
  unit: string;
  make: string;
  model: string;
  serial: string;
  status: string;
  commissioning_date: string;
  meter_url?: string;
  predicted_monthly?: number[];
};
export type PatchedMeterRequest = {
  name?: string;
  type?: string;
  unit?: string;
  make?: string;
  model?: string;
  serial?: string;
  status?: string;
  commissioning_date?: string;
  meter_url?: string;
  predicted_monthly?: number[];
};
